import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { ReactComponent as EditIcon } from 'img/icons/edit.svg';
import menuItems from 'common/messages/menuItems';
import ActionItem from 'common/components/ActionsMenu/ActionItem';

const useStyles = makeStyles({
  icon: {
    width: 16,
    height: 16,
  },
});

interface IActionItemEdit {
  key?: string;
  onClick: () => void;
  disabled?: boolean;
}

const ActionItemEdit: FC<IActionItemEdit> = ({ key = 'edit', onClick, disabled = false }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <ActionItem
      key={key}
      icon={<EditIcon className={classes.icon} />}
      onClick={onClick}
      disabled={disabled}
    >
      {intl.formatMessage(menuItems.edit)}
    </ActionItem>
  );
};

export default ActionItemEdit;
